import req from "@/assets/js/axios"

export default {
    // 设计师入驻平台
    createFrontDesigner: (params) => {
        return req.apiAxios('POST', '/designer/designerController/whale-security/createFrontDesigner', params)
    },
    // 编辑
    updateFrontDesigner: (params) => {
        return req.apiAxios('POST', '/business/designer/BDesignerController/whale-security/updateFrontDesigner', params)
    },
    
}